import React, {useEffect, useState} from "react";
import {Col, Row} from "react-bootstrap";
import {RequireAuth} from "Components/Security/RequireAuth";
import {DefaultContainer} from "Views/Shared/DefaultContainer";
import {useNavigate, useParams} from "react-router-dom";
import {Notificator} from "Services/Notificator/Notificator";
import {useMutation, useQuery} from "react-query";
import {useAppDispatch} from "hooks";
import {appLoading} from "Store/loadingSlice";
import {EnrollmentForm} from "./EnrollmentForm";
import {getEnrollmentDetail} from "../../Api/Query/Enrollments";
import {updateEnrollment} from "../../Api/Mutation/Enrollments";

export const EnrollmentEdit : React.FC = () => {

    const {id} = useParams()
    const navigate = useNavigate()
    const dispatch = useAppDispatch()

    const [entity, setEntity] = useState<any>({
        name: "",
        price: 0,
        enabled: false,
        activitySessions: []
    })

    const update = useMutation({
        mutationKey: [],
        mutationFn: (body: any) => updateEnrollment(body.id, body.data),
        onSuccess: () => {
            Notificator.success('La matricula se ha editado correctamente')
        },
        onError: () => {
            Notificator.error('Se ha producido un error al editar la matricula')
        }
    })

    const onSave = (data: any,) => {
        data = {
            ...data,
            price: parseFloat(data.price)
        }

        let finalData = data
        finalData = {
            ...finalData,
            activitySessions: data.activitySessions.map((item: any) => {
                return item.value
            })
        }

        update.mutate({
            id: id,
            data: finalData
        })
    }

    const query = useQuery({
        enabled: false,
        queryKey: ['getEnrollmentDetail', id],
        queryFn: () => getEnrollmentDetail(id ?? '-1'),
        onSuccess: (response: any) => {
            setEntity(response.data._result)
        },
        onError: () => {
            Notificator.error('Se ha producido un error al cargar los datos.')
        }
    })

    useEffect(() => {
        query.refetch()
    }, []);

    useEffect(() => {
        dispatch(appLoading({value: query.isLoading, text: 'Cargando'}))
    }, [query.isLoading])

    useEffect(() => {
        dispatch(appLoading({value: update.isLoading, text: 'Cargando'}))
    }, [update.isLoading])

    useEffect(() => {
        dispatch(appLoading({value: query.isRefetching, text: 'Cargando'}))
    }, [query.isRefetching])

    return (
        <RequireAuth>
            <DefaultContainer>

                <Col>

                    <Row>
                        <Col>
                            <h1 className={"pb-4"}>Detalle de la matrícula</h1>
                        </Col>

                    </Row>

                    <Row>
                        <EnrollmentForm
                            onSave={onSave}
                            entity={entity}
                        />
                    </Row>

                </Col>

            </DefaultContainer>
        </RequireAuth>
    )
}
